import { css } from '@emotion/css';
import { colors } from 'constants/theme';

interface Props {
    label: string;
    className?: string;
}
function TagLabel(props: Props) {
    const { label, className } = props;
    return (
        <div className={`${styles.wrap} ${className || ''}`}>
            <p className={styles.label}>{label}</p>
        </div>
    );
}

const styles = {
    wrap: css`
        border-radius: 8px;
        padding: 8px;
    `,
    label: css`
        font-size: 12px;
        color: ${colors.white};
    `,
};

export default TagLabel;
